export const SHORT_PDF = {
  value: "SHORT_PDF",
  key: "invoices.view.types.shortPDF",
};
export const SHORT_EXCEL = {
  value: "SHORT_EXCEL",
  key: "invoices.view.types.shortExcel",
};
export const LONG_PDF = {
  value: "LONG_PDF",
  key: "invoices.view.types.longPDF",
};
export const LONG_EXCEL = {
  value: "LONG_EXCEL",
  key: "invoices.view.types.longExcel",
};
export const SUMMARY_EXCEL = {
  value: "SUMMARY_EXCEL",
  key: "invoices.view.types.summaryExcel",
};
export const SHORT_INSURER_EXCEL = {
  value: "SHORT_INSURER_EXCEL",
  key: "invoices.view.types.shortInsurerExcel",
};
export const PREMIUM_BY_INSURER = {
  value: "PREMIUM_BY_INSURER",
  key: "invoices.view.types.premiumByInsurer",
};

export default [
  SHORT_PDF,
  SHORT_EXCEL,
  LONG_PDF,
  LONG_EXCEL,
  SUMMARY_EXCEL,
  SHORT_INSURER_EXCEL,
  PREMIUM_BY_INSURER,
];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/invoices/enums/invoiceViewTypes.js